import React from 'react';

export default function TextIcon(props:any) {
    return (
        <div className='collapseCardIconBox'>
            <div className='svg'>
                {props?.svg}
            </div>
            <div className='text' style={{color: props?.textColor}}>
                {props?.text}
            </div>
        </div>
    )
}